import React from 'react';

import { SvgIcon } from '@mui/material';
import classNames from 'classnames';

import { useStyles } from '../Icon.styles';
import { LegacyIconProps } from '../Icon.types';

export const ThumbsDown = ({
  size = 'default',
  color = 'secondary',
}: LegacyIconProps) => {
  const { classes } = useStyles();

  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(
        classes[`icon_size_${size}` as const],
        classes[`icon_color_${color}` as const],
      )}
    >
      <path
        d="M10.193 2.7449C6.74257 2.7449 4.95703 4.00545 4.47968 6.56287C3.91132 9.38904 5.94531 11.6179 6.74257 12.2969C7.58554 13.0144 8.37538 14.1453 8.29179 15.9527C8.18906 18.1777 10.5508 18.5 11.2668 16.4152C11.8715 14.6547 10.4777 12.4269 11.3531 11.4949C11.6666 11.195 12.5484 11.1014 12.5484 11.1014C12.9714 11.0409 13.7046 11.0292 13.9724 11.0212C15.7248 10.6463 14.428 9.57588 14.5043 8.63006C14.8691 7.43592 15.0538 2.7449 10.193 2.7449Z"
        fill="url(#paint0_radial_4706_230592)"
      />
      <path
        opacity="0.7"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.7465 12.3002C7.58799 13.018 8.37525 14.1481 8.29179 15.9527C8.18906 18.1777 10.5508 18.5 11.2668 16.4152C11.56 15.5614 11.3833 14.5978 11.2233 13.7253C11.0549 12.8075 10.9051 11.9905 11.3405 11.5086C11.3449 11.5041 11.3492 11.4995 11.3535 11.4949C11.952 10.8575 12.0604 10.5982 12.0534 10.5043C12.1159 10.5169 12.2393 10.5191 12.468 10.4856C14.4561 10.1946 14.4661 9.81022 14.4864 9.03155C14.4896 8.90805 14.493 8.77463 14.5047 8.63008C14.8695 7.43594 15.1167 2.74493 10.1934 2.74493H10.193C6.74257 2.74493 4.95703 4.00548 4.47968 6.5629C3.91132 9.38907 5.94531 11.618 6.74257 12.2969C6.74388 12.298 6.74519 12.2991 6.7465 12.3002Z"
        fill="url(#paint1_radial_4706_230592)"
      />
      <g filter="url(#filter0_f_4706_230592)">
        <path
          d="M5.68164 7.01103C10.0695 6.74423 8.16758 3.23173 11.0359 3.73173C11.7742 3.86064 11.7922 9.54462 11.7723 10.6497C10.5047 10.9388 10.8328 10.0591 10.8328 10.0591C10.8328 10.0591 10.0152 7.15322 5.68164 7.01064V7.01103Z"
          fill="url(#paint2_radial_4706_230592)"
        />
      </g>
      <path
        d="M8.09454 4.62184C7.89376 3.55309 8.72384 2.77809 9.80782 2.86637C11.0754 2.9695 11.7637 2.82614 11.9645 3.89489C12.1652 4.96364 11.4617 5.99255 10.393 6.19333C9.32423 6.39411 8.29532 5.69059 8.09454 4.62184Z"
        fill="url(#paint3_radial_4706_230592)"
      />
      <path
        d="M10.5638 5.44628C9.52983 5.34424 9.24897 3.58738 10.1951 3.20814C11.4603 2.7009 13.5431 2.64604 14.2986 3.1467C15.0541 3.64735 15.1935 4.90027 14.1958 5.25757C13.1978 5.61487 11.5978 5.54831 10.5638 5.44628Z"
        fill="url(#paint4_radial_4706_230592)"
      />
      <path
        d="M10.5638 5.44628C9.52983 5.34424 9.24897 3.58738 10.1951 3.20814C11.4603 2.7009 13.5431 2.64604 14.2986 3.1467C15.0541 3.64735 15.1935 4.90027 14.1958 5.25757C13.1978 5.61487 11.5978 5.54831 10.5638 5.44628Z"
        fill="url(#paint5_radial_4706_230592)"
      />
      <path
        d="M10.5638 5.44628C9.52983 5.34424 9.24897 3.58738 10.1951 3.20814C11.4603 2.7009 13.5431 2.64604 14.2986 3.1467C15.0541 3.64735 15.1935 4.90027 14.1958 5.25757C13.1978 5.61487 11.5978 5.54831 10.5638 5.44628Z"
        fill="url(#paint6_radial_4706_230592)"
      />
      <path
        d="M10.5638 5.44628C9.52983 5.34424 9.24897 3.58738 10.1951 3.20814C11.4603 2.7009 13.5431 2.64604 14.2986 3.1467C15.0541 3.64735 15.1935 4.90027 14.1958 5.25757C13.1978 5.61487 11.5978 5.54831 10.5638 5.44628Z"
        fill="url(#paint7_radial_4706_230592)"
      />
      <path
        d="M10.0293 4.07422C11.1166 4.07422 11.998 4.95566 11.998 6.04297C11.998 7.13028 11.1166 8.01172 10.0293 8.01172C8.94199 8.01172 8.06055 7.13028 8.06055 6.04297C8.06055 4.95566 8.94199 4.07422 10.0293 4.07422Z"
        fill="url(#paint8_radial_4706_230592)"
      />
      <path
        d="M10.6336 7.11988C9.43397 7.0215 8.86796 5.06422 10.2098 4.67584C11.7148 4.23991 14.0969 4.0779 14.9715 4.576C15.8461 5.0741 16.009 6.55668 14.8492 6.91764C13.6894 7.27859 11.8332 7.21825 10.6336 7.11988Z"
        fill="url(#paint9_radial_4706_230592)"
      />
      <path
        d="M10.6336 7.11988C9.43397 7.0215 8.86796 5.06422 10.2098 4.67584C11.7148 4.23991 14.0969 4.0779 14.9715 4.576C15.8461 5.0741 16.009 6.55668 14.8492 6.91764C13.6894 7.27859 11.8332 7.21825 10.6336 7.11988Z"
        fill="url(#paint10_radial_4706_230592)"
      />
      <path
        d="M10.6336 7.11988C9.43397 7.0215 8.86796 5.06422 10.2098 4.67584C11.7148 4.23991 14.0969 4.0779 14.9715 4.576C15.8461 5.0741 16.009 6.55668 14.8492 6.91764C13.6894 7.27859 11.8332 7.21825 10.6336 7.11988Z"
        fill="url(#paint11_radial_4706_230592)"
      />
      <path
        d="M10.6336 7.11988C9.43397 7.0215 8.86796 5.06422 10.2098 4.67584C11.7148 4.23991 14.0969 4.0779 14.9715 4.576C15.8461 5.0741 16.009 6.55668 14.8492 6.91764C13.6894 7.27859 11.8332 7.21825 10.6336 7.11988Z"
        fill="url(#paint12_radial_4706_230592)"
      />
      <path
        d="M14.064 11.0252C13.8965 11.0252 11.8082 11.0124 11.3539 11.496C10.4785 12.428 11.8723 14.6558 11.2676 16.4163C10.5516 18.5011 8.18945 18.1784 8.29258 15.9538C8.37617 14.1464 7.58633 13.0155 6.74336 12.298C6.45273 12.0507 5.99766 11.5972 5.56445 10.9839C8.05234 9.12765 10.7563 9.41579 12.3016 10.3228L14.064 11.0252Z"
        fill="url(#paint13_radial_4706_230592)"
      />
      <path
        d="M14.064 11.0252C13.8965 11.0252 11.8082 11.0124 11.3539 11.496C10.4785 12.428 11.8723 14.6558 11.2676 16.4163C10.5516 18.5011 8.18945 18.1784 8.29258 15.9538C8.37617 14.1464 7.58633 13.0155 6.74336 12.298C6.45273 12.0507 5.99766 11.5972 5.56445 10.9839C8.05234 9.12765 10.7563 9.41579 12.3016 10.3228L14.064 11.0252Z"
        fill="url(#paint14_radial_4706_230592)"
        fillOpacity="0.7"
      />
      <path
        d="M14.064 11.0252C13.8965 11.0252 11.8082 11.0124 11.3539 11.496C10.4785 12.428 11.8723 14.6558 11.2676 16.4163C10.5516 18.5011 8.18945 18.1784 8.29258 15.9538C8.37617 14.1464 7.58633 13.0155 6.74336 12.298C6.45273 12.0507 5.99766 11.5972 5.56445 10.9839C8.05234 9.12765 10.7563 9.41579 12.3016 10.3228L14.064 11.0252Z"
        fill="url(#paint15_radial_4706_230592)"
        fillOpacity="0.4"
      />
      <path
        opacity="0.7"
        d="M14.064 11.0252C13.8965 11.0252 11.8082 11.0124 11.3539 11.496C10.4785 12.428 11.8723 14.6558 11.2676 16.4163C10.5516 18.5011 8.18945 18.1784 8.29258 15.9538C8.37617 14.1464 7.58633 13.0155 6.74336 12.298C6.45273 12.0507 5.99766 11.5972 5.56445 10.9839C8.05234 9.12765 10.7563 9.41579 12.3016 10.3228L14.064 11.0252Z"
        fill="url(#paint16_radial_4706_230592)"
        fillOpacity="0.8"
      />
      <path
        d="M10.3672 7.69141C11.4545 7.69141 12.3359 8.57285 12.3359 9.66016C12.3359 10.7475 11.4545 11.6289 10.3672 11.6289C9.27988 11.6289 8.39844 10.7475 8.39844 9.66016C8.39844 8.57285 9.27988 7.69141 10.3672 7.69141Z"
        fill="url(#paint17_radial_4706_230592)"
      />
      <path
        d="M9.80762 5.94141C10.8949 5.94141 11.7764 6.82284 11.7764 7.91016C11.7764 8.99747 10.8949 9.87891 9.80762 9.87891C8.72031 9.87891 7.83887 8.99747 7.83887 7.91016C7.83887 6.82284 8.72031 5.94141 9.80762 5.94141Z"
        fill="url(#paint18_radial_4706_230592)"
      />
      <path
        d="M10.5502 9.00449C9.29473 8.87247 8.72832 7.05379 10.117 6.56045C11.8334 5.95081 14.558 5.93801 15.4553 6.43574C16.3525 6.93311 16.5182 8.4157 15.3283 8.77775C14.1385 9.1398 11.7775 9.13358 10.5502 9.00449Z"
        fill="url(#paint19_radial_4706_230592)"
      />
      <path
        d="M10.5502 9.00449C9.29473 8.87247 8.72832 7.05379 10.117 6.56045C11.8334 5.95081 14.558 5.93801 15.4553 6.43574C16.3525 6.93311 16.5182 8.4157 15.3283 8.77775C14.1385 9.1398 11.7775 9.13358 10.5502 9.00449Z"
        fill="url(#paint20_radial_4706_230592)"
      />
      <path
        d="M10.5502 9.00449C9.29473 8.87247 8.72832 7.05379 10.117 6.56045C11.8334 5.95081 14.558 5.93801 15.4553 6.43574C16.3525 6.93311 16.5182 8.4157 15.3283 8.77775C14.1385 9.1398 11.7775 9.13358 10.5502 9.00449Z"
        fill="url(#paint21_radial_4706_230592)"
      />
      <path
        d="M10.5502 9.00449C9.29473 8.87247 8.72832 7.05379 10.117 6.56045C11.8334 5.95081 14.558 5.93801 15.4553 6.43574C16.3525 6.93311 16.5182 8.4157 15.3283 8.77775C14.1385 9.1398 11.7775 9.13358 10.5502 9.00449Z"
        fill="url(#paint22_radial_4706_230592)"
      />
      <path
        d="M11.1526 10.7819C9.75139 10.6612 9.3401 9.14207 10.7273 8.63097C12.3968 8.01585 14.3499 8.27221 15.2582 8.64487C16.196 9.02959 16.324 10.6175 15.1643 10.9784C14.5241 11.1779 13.7546 10.9784 12.9349 10.9003C12.2144 10.8317 11.7536 10.8337 11.1526 10.7819Z"
        fill="url(#paint23_radial_4706_230592)"
      />
      <path
        d="M10.9786 10.7544C9.85384 10.66 9.31932 9.22049 10.7271 8.63083C12.3966 8.0157 14.3497 8.27207 15.2579 8.64472C16.1958 9.02945 16.3238 10.6266 15.164 10.9876C14.5477 11.1797 13.7977 11.0194 13.0124 10.9095C12.3228 10.8428 11.535 10.8414 10.9786 10.7544Z"
        fill="url(#paint24_radial_4706_230592)"
      />
      <defs>
        <filter
          id="filter0_f_4706_230592"
          x="5.4082"
          y="3.40918"
          width="6.6416"
          height="7.57227"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.136719"
            result="effect1_foregroundBlur_4706_230592"
          />
        </filter>
        <radialGradient
          id="paint0_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.7215 16.4879) scale(14.3293)"
        >
          <stop stopColor="#FFF1B6" />
          <stop offset="0.7" stopColor="#FFD400" />
          <stop offset="1" stopColor="#FFB100" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.4649 8.20397) rotate(160.304) scale(7.1343 10.8298)"
        >
          <stop offset="0.564882" stopColor="#FFD400" stopOpacity="0" />
          <stop offset="1" stopColor="#FF8E00" stopOpacity="0.85" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.9823 6.92938) rotate(-178.409) scale(4.42237 5.48846)"
        >
          <stop offset="0.154202" stopColor="#C62400" stopOpacity="0.8" />
          <stop offset="1" stopColor="#FFD400" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.1101 4.41877) rotate(12.8877) scale(1.80892)"
        >
          <stop stopColor="#A80000" />
          <stop offset="1" stopColor="#FFD400" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.4441 4.2225) rotate(178.53) scale(3.60816 1.60209)"
        >
          <stop stopColor="#FFF1B6" />
          <stop offset="0.7" stopColor="#FFD400" />
          <stop offset="1" stopColor="#F7B700" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.8888 4.8314) rotate(-173.738) scale(3.79489 1.3501)"
        >
          <stop offset="0.369792" stopColor="#DA4E00" stopOpacity="0.5" />
          <stop offset="1" stopColor="#FFE918" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.2216 4.72968) rotate(177.163) scale(3.30407 1.5915)"
        >
          <stop stopColor="#F76D42" />
          <stop offset="1" stopColor="#F7B701" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.6134 4.87943) scale(4.42617 4.14385)"
        >
          <stop offset="0.79" stopColor="#FFD400" stopOpacity="0" />
          <stop offset="0.99" stopColor="#FF8E00" stopOpacity="0.4" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.0407 6.15328) rotate(-10.64) scale(2.08594)"
        >
          <stop stopColor="#A80000" />
          <stop offset="1" stopColor="#FFD400" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.0107 5.88368) rotate(179.036) scale(4.46632 2.00717)"
        >
          <stop stopColor="#FFF1B6" />
          <stop offset="0.7" stopColor="#FFD400" />
          <stop offset="1" stopColor="#F7B700" />
        </radialGradient>
        <radialGradient
          id="paint10_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.1542 6.74934) rotate(-175.625) scale(4.2552 1.51385)"
        >
          <stop offset="0.44" stopColor="#DA4E00" stopOpacity="0.5" />
          <stop offset="1" stopColor="#FFE918" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint11_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.0817 6.78215) rotate(-175.362) scale(3.29965 1.44617)"
        >
          <stop stopColor="#F76D42" />
          <stop offset="1" stopColor="#F7B701" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint12_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.2348 6.91874) scale(4.69687 4.39729)"
        >
          <stop offset="0.79" stopColor="#FFD400" stopOpacity="0" />
          <stop offset="0.99" stopColor="#FF8E00" stopOpacity="0.4" />
        </radialGradient>
        <radialGradient
          id="paint13_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1.10904 13.8536) rotate(-3.76058) scale(10.5241 17.2596)"
        >
          <stop offset="0.812811" stopColor="#FFD400" stopOpacity="0" />
          <stop offset="0.959491" stopColor="#FF9C1F" stopOpacity="0.8" />
        </radialGradient>
        <radialGradient
          id="paint14_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.71248 14.1084) rotate(-11.5806) scale(2.55984 4.45677)"
        >
          <stop stopColor="#FF8E00" stopOpacity="0.9" />
          <stop offset="1" stopColor="#FFD400" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint15_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.9725 12.6901) rotate(-40.4094) scale(1.99766 2.74871)"
        >
          <stop stopColor="#FF8E00" stopOpacity="0.9" />
          <stop offset="1" stopColor="#FFD400" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint16_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.49311 11.3934) rotate(9.90436) scale(6.91024 9.84462)"
        >
          <stop offset="0.315291" stopColor="#FFC42E" stopOpacity="0" />
          <stop offset="0.846569" stopColor="#FF7DBE" />
        </radialGradient>
        <radialGradient
          id="paint17_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.5161 9.73268) rotate(-10.2996) scale(1.94367)"
        >
          <stop stopColor="#BA4E00" />
          <stop offset="1" stopColor="#FFD400" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint18_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.8188 8.02045) rotate(-10.64) scale(2.08594)"
        >
          <stop stopColor="#A81E00" />
          <stop offset="1" stopColor="#FFD400" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint19_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.9446 7.52191) rotate(177.687) scale(4.54194 2.31243)"
        >
          <stop stopColor="#FFF1B6" />
          <stop offset="0.7" stopColor="#FFD400" />
          <stop offset="1" stopColor="#F7B700" />
        </radialGradient>
        <radialGradient
          id="paint20_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.0145 8.95296) rotate(-172.737) scale(3.94235 1.6129)"
        >
          <stop offset="0.44" stopColor="#DA4E00" stopOpacity="0.5" />
          <stop offset="1" stopColor="#FFE918" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint21_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.3224 8.66089) rotate(-175.673) scale(3.62978 1.48502)"
        >
          <stop stopColor="#F76D42" />
          <stop offset="1" stopColor="#F7B701" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint22_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.9475 8.9233) scale(4.56289 4.27185)"
        >
          <stop offset="0.79" stopColor="#FFD400" stopOpacity="0" />
          <stop offset="0.99" stopColor="#FF8E00" stopOpacity="0.4" />
        </radialGradient>
        <radialGradient
          id="paint23_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.5227 9.86673) rotate(178.53) scale(4.624 2.29462)"
        >
          <stop stopColor="#FFF1B6" />
          <stop offset="0.7" stopColor="#FFD400" />
          <stop offset="1" stopColor="#F7B700" />
        </radialGradient>
        <radialGradient
          id="paint24_radial_4706_230592"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.2044 10.4842) scale(4.87656 4.56552)"
        >
          <stop offset="0.79" stopColor="#FFD400" stopOpacity="0" />
          <stop offset="0.99" stopColor="#FF8E00" stopOpacity="0.4" />
        </radialGradient>
      </defs>
    </SvgIcon>
  );
};
